import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { API } from './apiutil';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class VoteService {
    http;
    constructor(http) {
        this.http = http;
    }
    create(data) {
        return this.http.post(`${environment.base}/vote`, data);
    }
    search(ctx) {
        return this.http.get(`${environment.base}/vote`, {
            params: API.makeParams(ctx),
        });
    }
    getById(id) {
        return this.http.get(`${environment.base}/vote/${id}`);
    }
    update(id, data) {
        return this.http.put(`${environment.base}/vote/${id}`, data);
    }
    delete(id) {
        return this.http.delete(`${environment.base}/vote/${id}`);
    }
    listSubmitted(ctx) {
        return this.http.get(`${environment.base}/vote/submitted`, {
            params: API.makeParams(ctx),
        });
    }
    static ɵfac = function VoteService_Factory(t) { return new (t || VoteService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: VoteService, factory: VoteService.ɵfac });
}
